import { useEffect, useState } from "react";
import arrow from "../Assets/arrow.png";
import Collectioncard from "./collectioncard";
import { Link } from "react-router-dom";
import rightarrow from "../Assets/rightarrow.png";
import OwlCarousel from "react-owl-carousel";
import { CollectionByCreator } from "../services/collection.api";
import Nodata from "./nodata";

export const CollectionList = () => {
  const options = {
    items: 5,
    responsiveClass: true,
    loop: false,
    margin: 30,
    autoplay: false,
    dots: false,
    nav: true,
    navText: [
      `<img src=${rightarrow} class='leftside' />`,
      `<img src=${rightarrow} class='leftcaroimg' />`,
    ],
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1199: {
        items: 3,
      },
      1200: {
        items: 3,
      },
      1400: {
        items: 4,
      },
      1800: {
        items: 5,
      },
    },
  };

  let init = {
    All: undefined,
  };
  const [Collectionsdata, Setcollectionsdata] = useState(init);
  const [TabName, SetTabName] = useState("All");

  var [filter, setFilter] = useState("PLTH");

  useEffect(() => {
    // if (typeof Collectionsdata[TabName] == "undefined") {
    Collectionsdata[TabName] = { page: 1, list: [], loader: false };
    Setcollectionsdata(Collectionsdata);
    CollectionByCreate(1, TabName);
    // }
  }, [TabName, filter]);

  const CollectionByCreate = async (page, tab) => {
    var SendDATA = {
      from: "collctionpage",
      TabName: "collection",
      limit: 12,
      page: page ?? 1,
      Categoryname: tab ? tab : TabName,
      filter: filter,
    };
    //   let Resp = await Token_MyList_Func(SendDATA);
    let Resp = await CollectionByCreator(SendDATA);

    if (Resp?.data) {
      Setcollectionsdata({
        ...Collectionsdata,
        ...{
          [TabName]: {
            list: Collectionsdata[TabName]?.list
              ? [...Collectionsdata[TabName]?.list, ...Resp?.data]
              : Resp?.data,
            page: Collectionsdata[TabName]?.page,
            loader: Resp.data.length < 12 ? false : true,
          },
        },
      });
    }
  };

  return (
    <>
      <div className="">
        <h2 className="heading pt-3 pb-3">
          Collections{" "}
          <img src={arrow} className="img-fluid titleimg" alt="images" />
        </h2>
        {Collectionsdata[TabName]?.list?.length !== 0 ? (
          <OwlCarousel className="owl-theme" nav {...options}>
            {Collectionsdata[TabName]?.list?.map((val, i) => (
              <div class="item">
                <Link
                  to={`/nftlist/${val?.CollectionSymbol}`}
                  state={{ cardtype: "explore" }}
                >
                  <Collectioncard state={{ cardtype: "explore" }} props={val} />
                </Link>
              </div>
            ))}
          </OwlCarousel>
        ) : (
          <Nodata />
        )}
      </div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </>
  );
};
